import { useEffect } from 'react';
import { useLocalStorage } from '~/shared/hooks/useLocalStorage';
import { SFProduct } from '../pdp.definitions';

export const useViewedProducts = (product?: SFProduct | null) => {
    const [value, setValue] = useLocalStorage<SFProduct[] | undefined>('ViewedProducts');

    const save = (product: SFProduct) => {
        const { c_pageURL: url, id, name } = product;
        const image = product?.images?.[0]; // Adjust this line according to how your `images` are structured in `SFProduct`

        const partialProduct = { url, id, image, name };

        if (Array.isArray(value)) {
            setValue([partialProduct, ...value]);
            return;
        } else {
            setValue([partialProduct]);
        }
    };

    useEffect(() => {
        if (!product) return;

        const { c_pageURL: url, id, name } = product;
        const image = product?.images?.[0]; // Adjust this line according to how your `images` are structured in `SFProduct`

        const partialProduct = { url, id, image, name };

        if (Array.isArray(value)) {
            if (value.some((p) => p.id === id)) {
                return;
            }
            setValue([partialProduct, ...value]);
        } else {
            setValue([partialProduct]);
        }
    }, [product, value, setValue]);

    return {
        save,
        value,
    };
};
